import axios from 'axios';

const instance = axios.create({
  baseURL: `https://api.manatal.com/open/v3/`,
});

instance.interceptors.request.use(
  config => config,
  err => Promise.reject(err),
);

instance.interceptors.response.use(
  res => res,
  err => {
    return Promise.reject(err);
  },
  config => {
    return config;
  },
);


export default instance;
